import { ApolloError } from '@apollo/client';

import {
  useErpCareerDirectionsQuery,
  ErpCareerDirectionsQuery,
} from 'core/graphql';

export type ICareerDirection = NonNullable<
  ErpCareerDirectionsQuery['careerDirections'][number]
>;

// Stable empty fallback — see the note in `useCareerMembers`.
const EMPTY_DIRECTIONS: ICareerDirection[] = [];

interface ICareerDirectionsHook {
  directions: ICareerDirection[];
  loading: boolean;
  error?: ApolloError;
}

/**
 * Spec 0018 — the direction reference list, used by the members filter and by
 * the enrolment popup.
 *
 * `includeInactive` defaults to `false`: a retired direction must stay
 * readable on the members already tagged with it (that title arrives inline on
 * `CareerMemberType.directionTitle`), but must not be offered as a new choice.
 */
export const useCareerDirections = (
  includeInactive = false,
): ICareerDirectionsHook => {
  const { data, loading, error } = useErpCareerDirectionsQuery({
    variables: { includeInactive },
    fetchPolicy: 'cache-and-network',
  });

  return {
    directions: data?.careerDirections ?? EMPTY_DIRECTIONS,
    loading,
    error,
  };
};
